import { useFormStore } from '@/stores/form';
var __default__ = {
  layout: 'blank'
};
export default /*#__PURE__*/Object.assign(__default__, {
  __name: '_id',
  setup: function setup(__props) {
    var store = useFormStore();
    var route = useRoute();
    onMounted(function () {
      var _route$query;
      store.clearStore();
      validateCampaignQuery(route.query.campaign);
      store.referral = (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.referral;
      window.location.href = "/lidmaatschap?club=".concat(route.params.id);
    });
    function validateCampaignQuery(campaign) {
      if (campaign && campaign.length < 128) {
        store.campaign = campaign;
      }
    }
    return {
      __sfc: true,
      store: store,
      route: route,
      validateCampaignQuery: validateCampaignQuery
    };
  }
});